import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Syrian() {
  return (
    <ApiCommunityDirectoryPage
      community="Syrian"
      eyebrow="Syrian community guide"
      title="Syrian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Syrian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Syrian community guide?"
      modalIdPrefix="syrian-directory"
    />
  );
}
